import { ToastrManager } from 'ng6-toastr-notifications';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Stock } from '../stock.model';
import { StockService } from '../stock.service';

@Component({
    selector: 'ng-stock-detail',
    templateUrl: 'stock-detail.component.html',
    styleUrls:['./stock-detail.component.css']
})

export class StockDetailComponent implements OnInit {

    public stock:Stock;

    public modal:string;

    private detailSubscription:Subscription;

    public arrayOfimagesUrls: Array<string>;

    public arrayOfimages: Array<any>;

    public isButtonLoading: boolean;
  
    constructor(public stockService: StockService,public navigator:Router,public toastr:ToastrManager) {
      this.detailSubscription=new Subscription();
      this.arrayOfimages=new Array<any>();
      this.arrayOfimagesUrls=new Array<string>();
      this.isButtonLoading=false;
     }
  
    ngOnDestroy(): void {
      if(this.detailSubscription) return
  
      this.detailSubscription.unsubscribe();
    }
  
    ngOnInit() {
      this.detailSubscription.add(this.stockService.getObject('stock').subscribe(stock=>this.stock=stock));
    }
  
    editStock(stock:Stock){
      this.navigator.navigate(['/admin/stock/edit']).then(()=>{
        this.stockService.setObject(stock,'stock');
      })
    }
  
    updateImage(event:any,image:any){
  
      if(confirm('Deseja realmente actualizar a Imagem?')){
  
              // criando um formData
              let formData = new FormData();
  
              // convertendo o formproduct para formData
              formData.append('id', image['id'])
        
              // Anexando a imagem
              if(event.target.files[0])
                formData.append('image', event.target.files[0], event.target.files[0].name)
  
        // save image
        this.stockService.updateIndividualImage(formData,'product')
        .subscribe(message=>{
          this.toastr.successToastr(message)
        })
  
      }
    }

    public previewSelectedImages(event:any):void{

        let index=0;

        if (event.target.files && event.target.files[0]) {

          var filesAmount = event.target.files.length;

          index=event.target.files.length;
    
          if(index>3 || this.arrayOfimages.length>2){ alert('Não é permitido carregar mais de 3 imagens'); return }

          for (let i = 0; i < filesAmount; i++) {
              
              var reader = new FileReader();

              this.arrayOfimages.push(event.target.files[i]); 

              reader.onload = (event:any) => {

                this.arrayOfimagesUrls.push(event.target.result);

              }
              
              reader.readAsDataURL(event.target.files[i]);

          }

        }
    
    }
    
    public removeSelectedImage(url:string){
        let  index=this.arrayOfimagesUrls.indexOf(url)
        this.arrayOfimagesUrls.splice(index,1)
        this.arrayOfimages.splice(index,1)
    }

    public removeAllSelectedImages(){
        this.arrayOfimagesUrls=[];
        this.arrayOfimages=[]
    }

    saveImagesOfStock(){

        this.isButtonLoading=true;

        let formData=new FormData();

        formData.append('id',''+this.stock.id);
        
        if(this.arrayOfimages.length==0){
            alert("Para salvar precisa de pelo menos uma imagem");
            return
        }

        for(let index=0;index<this.arrayOfimages.length;index++) {
            formData.append('images[]',this.arrayOfimages[index],this.arrayOfimages[index].name);
        }

        this.detailSubscription.add(this.stockService.updateImageWithNoData(formData,'stock')
        .subscribe(message=>{
            this.toastr.successToastr(message);
            this.isButtonLoading=false;
            this.arrayOfimages=[]; 
            this.arrayOfimagesUrls=[]; 
        }))

    }
  }